import React from "react";
import { ShopForm } from "../../forms/ShopForm";
import { sAddShop } from "../../constants/strings";
import { CreateDrawer } from "../../components/drawer/DrawerComponent";
import { ShopsRegister } from "./ShopsRegister";

export const Shops = () => {
  return (
    <div>
      <CreateDrawer title={sAddShop} form={<ShopForm />} />
      <ShopsRegister />
    </div>
  );
};
